import type { RouteObject } from 'react-router';

import { HOURS_PATH } from '../../app/config';

/**
 * W6 "Mes heures", as route data for the router.
 *
 * The feature exports routes rather than editing `app/router.tsx`: the router
 * owns the authorization nesting, and a feature reaching into it could mount a
 * payroll screen outside a guard.
 */
export const hoursRoutes: RouteObject[] = [
  {
    path: HOURS_PATH,
    lazy: async () => ({ Component: (await import('./MyHoursPage')).MyHoursPage }),
  },
];

/** The name the feature brief asks every feature to export. Same array. */
export const routes = hoursRoutes;
